module.exports = "/fonts/TT-Norms-Regular.ttf";